import FpLoaderSomethingBlue from './FpLoaderSomethingBlue.jsx'
export default FpLoaderSomethingBlue
